import { GraySpinner, VStack } from "goi_common";
import { createContext, ReactNode } from "react";

interface LoadingContextType {
  isLoading: boolean;
}

const LoadingContext = createContext<LoadingContextType>({
  isLoading: true,
});

const LoadingProvider = ({ children, isLoading }: { children: ReactNode; isLoading: boolean }) => {
  return (
    <LoadingContext.Provider value={{ isLoading }}>
      {isLoading ? (
        <VStack
          width="100%"
          height="calc(100vh - 84px)"
          justifyContent="center"
          alignItems="center"
        >
          <GraySpinner />
        </VStack>
      ) : (
        children
      )}
    </LoadingContext.Provider>
  );
};

export default LoadingProvider;
